const messages = {
    availPoints: "Dostupné body",
    awaitingPoints: "Čakajúce body",
  board: {
    title: "Prehľad",
    title2: "Animácia výkonu {year}",
    headline1: "Vaše akcie a body na prvý pohľad",
    headline2: "Získajte body za nákup pneumatík.",
    pointsBalanceToDate: "STAV BODOV K DÁTUMU",
    availPoints: "Dostupné body",
    awaitingPoints: "Čakajúce body",
    yourRealisation: "VAŠE ÚSPECHY",
    yourEngagement: "Váš ročný záväzok: <b>{tyres} pneumatiky</b>",
    yourPoints: "VAŠE BODY",
    yourRetailPurchase: "VAŠE MALOOBCHODNÉ NÁKUPY",
    yourRetailPurchaseCCS: "VÁŠ MALOOBCHODNÝ PREDAJ",
    pointsByPurchase: "body generované vašimi nákupmi",
    pointsByBoosters: "body generované boostermi",
    pointsByBSPurchase: "Body vygenerované vašimi nákupmi Bridgestone",
    pointsByBSPurchaseCCS:
      "Body generované predajom pneumatík Bridgestone",
    remaining: "Zostávajúce pneumatiky",
    yourGoal: "Cieľový postup",
    unit: "pneumatiky",
    buttons: {
      learnMore: "Zistite viac o svojich bodoch",
      learnMoreAboutMechanism: "Zistite viac o mechanike",
    },
    charts: {
      byBrand: "Podľa značky",
      bySize: "Podľa<br/>veľkosti ráfika",
    },
    exploreResults: "Objavte svoje výsledky",
    tyreLimitInfo:
      "Pre každé obdobie kampane Booster sa vyžaduje minimálny vypredaný objem 50 pneumatík Bridgestone a/alebo Firestone",
  },
  charts: {
    byBrand: "Podľa značky",
    bySize: "podľa veľkosti ráfika",
  },

  dashboard: {
    dashboardTitle: "Vaše výhody",
    dashboardBox: {
      title: "Zostatok bodov",
      description: "Celkový súčet vašich aktuálnych marketingových bodov",
      availPoints: "Dostupné body",
      awaitingPoints: "Čakajúce body",
      lastUpdate: "Posledná aktualizácia",
      button: "Zistite viac",
      points: "points",
    },
  },
  soldTyres: "PNEUMATIKY PREDANÉ",
  receivedPoints: "ZÍSKANÉ BODY",
  boosterCCS: {
    personalInfo: "Osobné údaje",
    csNumberTitle: "Uveďte čísla účastníckych účtov",
    tyresTitle: "Uveďte počet predaných pneumatík",
    minTyresInfo:
      "Vyžaduje sa minimálne {tyres} pneumatiky Bridgestone/Firestone. Kompenzácia sa vzťahuje len na pneumatiky Bridgestone.",
    tyresAmount: "Počet pneumatík",
    filesTitle: "Nahrajte svoj doklad o predaji",
    filesDescription:
      "Poznámka: Do úvahy sa budú brať iba predaje špecifikujúce veľkosť ráfika pneumatiky.",
    addAnotherFile: "Pridajte ďalší dokument",
    file: "Nahrajte dokument",
    formatInfo:
      "Akceptované formáty súborov: xlsx, jpeg a pdf. Maximálna veľkosť súboru: 8 MB",
    confrimationMessage:
      "<b>Ďakujeme za vašu účasť!</b> <br/>Vaša žiadosť bola prijatá a preposlaná tímom Bridgestone na overenie.<br/>Dostanete e-mailové upozornenie s výsledkami vašej účasti v Booster CCS.<br/>Čoskoro sa uvidíme na Bridgestone Plus!",
  },
  sharePointModal: {
    header: "Zdieľajte body",
    forShare: "Body, ktoré budete zdieľať",
    title: "Názov",
  },
  notFoundFile: "Nie je vybratá žiadna",
  chooseFile: "Vyberte súbor",
};
export default {
  messages,
};
